import ResourceList from '../../resource/list';

const AssetsList = () => {

      return(
        <div>
          <ResourceList resource="backgrounds" name="Backgrounds"/>
        </div>
      )

}

export default AssetsList;